export default {
  methods: {
    // 修改附件
    // eslint-disable-next-line consistent-return
    updateAnnex(row, validateAction, postAction, key) {
      this.buttonDisabled = false;
      if (this.computeDisabled(row, key)) {
        return null;
      }
      this.uploadStatus = '';
      this.uploadFileObj = {};
      this.uploadText = '点击上传';
      this.uploadTip = '';
      this.unsuccessEditObj = {
        ...row,
      };
      this.$set(this.editFormData, 'fileName', '上传文件后，此栏自动显示');
      this.handleSelectType();
      // 选中默认值
      // {this.editFormData} = {row}
      this.editing = true;
      // eslint-disable-next-line no-shadow
      Object.keys(this.editFormData).forEach((key) => {
        this.editFormData[key] = row[key];
      });
      this.editFormData.annexSize = row.fileSize;

      this.visibleEdit = true;
    },
    EditAnnex() {
      // 校验表单数据
      this.uploadStatus = '';
      this.uploadText = '点击上传';
      // this.uploadTip = '';
      // eslint-disable-next-line no-empty
      if (this.canupload) {
        if (this.validate(this.editRules, this.editFormData)) {
          this.$_yh_confirm(this.$MSG.M0179, '修改公共附件', {
            confirmButtonText: '确定',
          }).then(() => {
            this.postEditAnnex();
          });
        }
      } else {
        this.$message.error('请上传文件，等待文件上传成功');
      }
    },
    postEditAnnex() {
      this.buttonDisabled = true;
      // eslint-disable-next-line no-self-compare
      if (Number(this.editFormData.productType) !== Number(this.editFormData.productType)) {
        // eslint-disable-next-line max-len
        this.editFormData.productType = this.typeOptions.filter(r => r.dictName === this.editFormData.productType)[0].dictValue;
      }
      const { fileUrl, id } = this.uploadFileObj;
      if (Object.keys(this.uploadFileObj).length === 0) {
        // 没有上传成功，取当前行的文件名，文件大小
        this.editFormData.fileName = this.unsuccessEditObj.fileName;
        this.editFormData.annexSize = this.unsuccessEditObj.fileSize;
      }
      const parames = {
        data: {
          ...this.editFormData,
          fileSize: this.editFormData.annexSize,
          fileUrl,
          fileId: id,
        },
      };
      this.$_post(this.$API.updateAnnex, parames).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(`${this.$MSG.M0180}`);
          this.visibleEdit = false;
          this.editing = false;
          this.listAnnex();
        } else {
          this.$message.error(`${this.$MSG.M0030}`);
        }
      }).catch(() => {

      });
    },
    computeStatus(row) {
      if (!row.enableStatus) {
        return '';
      }
      const statusObj = {
        1: '禁用',
        0: '启用',
      };
      return statusObj[row.enableStatus] || '';
    },
    // 启用禁用
    // eslint-disable-next-line consistent-return
    EDisables(row, key) {
      // 启用禁用后刷新列表
      if (this.computeDisabled(row, key)) {
        // 禁用点击事件
        return null;
      }
      const tip = {
        1: '禁用后，用户购买该产品类型下任意产品时，外屏将不再显示该附件，确定要禁用吗？',
        0: '启用后，用户购买该产品类型下任意产品时，外屏将显示该附件，确定要启用吗？',
      };
      this.$_yh_confirm(`${tip[row.enableStatus]}`, '提示', {
        confirmButtonText: '确定',
      }).then(() => {
        this.postEDisables(row);
      });
    },
    postEDisables(row) {
      const statusObj = ['0', '1'];
      const editStatus = statusObj.filter(s => s !== row.enableStatus)[0] || '';
      const parames = {
        data: {
          id: row.id,
          enableStatus: editStatus,
        },
      };
      this.$_post(this.$API.changeStatus, parames).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(`${row.enableStatus === '1' ? this.$MSG.M0186 : this.$MSG.M0184}`);
          this.listAnnex();
        } else {
          this.$message.error(`${this.$MSG.M0030}`);
        }
      });
    },
    // 删除附件
    // eslint-disable-next-line consistent-return
    deleteAttachment(row, key, flag) {
      if (this.computeDisabled(row, key, flag)) {
        // 禁用点击事件
        return null;
      }
      this.$_yh_confirm(`${this.$MSG.M0181}`, '提示', {
        confirmButtonText: '确定',
      }).then(() => {
        this.postDelete(row);
      });
    },
    postDelete(row) {
      // 提交删除请求
      const parames = {
        data: {
          id: row.id,
        },
      };
      this.$_post(this.$API.deleteAnnex, parames).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(`${this.$MSG.M0182}`);
          this.listAnnex();
        } else {
          this.$message.error(`${this.$MSG.M0030}`);
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    // 产品类型下拉框
    handleSelectType() {
      const parames = {
        data: {
          dictTypeCode: 'prdType',
        },
      };
      this.$_post(this.$API.selectType, parames).then((res) => {
        this.typeOptions = res.data.list;
      }).catch(() => {

      });
    },


  },
};
